import src from "IMAGE";
export default { src, width: 546, height: 94, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AEtLS0RNTU1FSkpKQkxMTENAQEA3QUFBNkNDQzlbW1tOk1gI6ouwOTEAAAAASUVORK5CYII="};
